<template>
    <div>
        <div class="flex-page-content flex-container">
            <div class="flex-body body-scroll">
                <div class="container-fluid">

                    <div class="container-centered-s py-4">

                        <h5>{{ onboardingApplication.company.name }}</h5>
                        <h3>Resident Address Details</h3>

                        <form @submit.prevent="onSubmit" class="mt-2">
                            <form-errors :errors="formErrors" :errorsHtml="formErrorsHtml" />

                            <div class="form-row">
                                <div class="col">
                                    <form-input v-model="formData.geocode_choice_idx" :errors="errors.geocode_choice_idx" type="radio" :options="geocodeChoiceOptions" label="Please select the town/city in which you live."/>
                                </div>
                            </div>

                            <alert-box type="caution">
                            {{ geocodeDisclaimer }}
                            </alert-box>

                            <div class="row mb-2 d-flex align-items-center">
                                <div class="col">
                                    <router-link v-if="previousPage" :to="previousPage">Back</router-link>
                                </div>

                                <div class="col text-right">
                                    <button class="btn btn-primary">Continue</button>
                                </div>
                            </div>
                        </form>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>


<script>
import FormMixin from '@/mixins/Form'
import api from '@/api'
import WizardMixin from './WizardMixin'

export default {
    mixins: [FormMixin, WizardMixin],
    props: ['onboardingApplication', ],
    computed: {
        geocodeChoiceOptions() {
            const result = []
            this.onboardingApplication.geocode_data['geocode_choices']['geocode_choices'].forEach((c, idx) => {
                result.push({text: c['JURNAME'].toUpperCase(), value: idx})
            })
            return result
        },
        geocodeDisclaimer() {
            let state = this.onboardingApplication.geocode_data['state']
            return this.geocodeDisclaimers[state] || this.geocodeDisclaimers['default']
        }
    },
    data() {
        return {
            formRules: {
                'geocode_choice_idx': {
                    presence: {
                        allowEmpty: false,
                        message: "is required"
                    },
                }
            },
            formLabels: {
                'geocode_choice_idx': 'Town/City Selection',
            },
            formErrorsHtml: [],
            formData: this.makeFormData(),
            geocodeDisclaimers: {
                'default': 'This selection may affect your taxes. If you have questions regarding your jurisdiction, please verify with a trusted resource, such as a state or local government office.',
                'OH': 'This selection may affect your taxes. If you have questions regarding your jurisdiction, please verify with your County Auditor or contact the Department of Taxation.'
            }
        }
    },
    methods: {
        makeFormData() {
            return {
                action: 'give-address-details',
                geocode_choice_idx: this.onboardingApplication.geocode_choice_idx,
            }
        },
        getFormData() {
            return this.formData
        },
        onSubmit() {
            if (!this.validate()) {
                return
            }

            this.$store.dispatch('START_LOADING')
            api.patch(`/me/onboarding/${this.onboardingApplication.id}/onboarding-application`, this.getFormData()).then((resp) => {
                this.$emit('updated', resp)
                this.$emit('next')
                this.$store.dispatch('STOP_LOADING')
            }).catch((errors) => {
                this.errors = errors
                this.formErrorsHtml = errors.__all__
                this.onError()
                this.$store.dispatch('STOP_LOADING')
            })
        },
        reset: function() {
            this.errors = {}
            this.formErrorsHtml = []
            this.formData = this.makeFormData()
        },
    },
}
</script>
